module.exports = __webpack_public_path__ + "9f1378e847ff1707fecc0cecae484305.webp";